import { isChrome, isEdge, isFirefox } from 'react-device-detect';

export const isPushNotificationsAllowed = Boolean(isChrome || isFirefox || isEdge);
